/* eslint-disable require-await */
'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var multihash = require('multihashes');
/**
 * @typedef {import('multihashes').HashName} HashName
 * @typedef {import('./types').Digest} Digest
 */

/**
 * @type {Crypto}
 */


var crypto = self.crypto || self.msCrypto;
/**
 *
 * @param {Uint8Array} data
 * @param {HashName} alg
 * @returns {Promise<Uint8Array>}
 */

var digest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data, alg) {
    var d;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof self === 'undefined' || !crypto)) {
              _context.next = 2;
              break;
            }

            throw new Error('Please use a browser with webcrypto support and ensure the code has been delivered securely via HTTPS/TLS and run within a Secure Context');

          case 2:
            _context.t0 = alg;
            _context.next = _context.t0 === 'sha1' ? 5 : _context.t0 === 'sha2-256' ? 10 : _context.t0 === 'sha2-512' ? 15 : _context.t0 === 'dbl-sha2-256' ? 20 : 28;
            break;

          case 5:
            _context.t1 = Uint8Array;
            _context.next = 8;
            return crypto.subtle.digest({
              name: 'SHA-1'
            }, data);

          case 8:
            _context.t2 = _context.sent;
            return _context.abrupt("return", new _context.t1(_context.t2));

          case 10:
            _context.t3 = Uint8Array;
            _context.next = 13;
            return crypto.subtle.digest({
              name: 'SHA-256'
            }, data);

          case 13:
            _context.t4 = _context.sent;
            return _context.abrupt("return", new _context.t3(_context.t4));

          case 15:
            _context.t5 = Uint8Array;
            _context.next = 18;
            return crypto.subtle.digest({
              name: 'SHA-512'
            }, data);

          case 18:
            _context.t6 = _context.sent;
            return _context.abrupt("return", new _context.t5(_context.t6));

          case 20:
            _context.next = 22;
            return crypto.subtle.digest({
              name: 'SHA-256'
            }, data);

          case 22:
            d = _context.sent;
            _context.t7 = Uint8Array;
            _context.next = 26;
            return crypto.subtle.digest({
              name: 'SHA-256'
            }, d);

          case 26:
            _context.t8 = _context.sent;
            return _context.abrupt("return", new _context.t7(_context.t8));

          case 28:
            throw new Error("".concat(alg, " is not a supported algorithm"));

          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function digest(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = {
  /**
   * @param {HashName} alg
   * @returns {Digest}
   */
  factory: function factory(alg) {
    return /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", digest(data, alg));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }();
  },
  digest: digest,

  /**
   * @param {Uint8Array} buf
   * @param {HashName} alg
   * @param {number} [length]
   */
  multihashing: function () {
    var _multihashing = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(buf, alg, length) {
      var h;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return digest(buf, alg);

            case 2:
              h = _context3.sent;
              return _context3.abrupt("return", multihash.encode(h, alg, length));

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function multihashing(_x4, _x5, _x6) {
      return _multihashing.apply(this, arguments);
    }

    return multihashing;
  }()
};